var HEADER;
var LARGURA_MOBILE = 500;
var TELA_DESKTOP = true;
var TELA_MOBILE = false;
var MENU_LATERAL;
var HEADER_INIT, HEADER_FIM;
var MENU_INIT, MENU_FIM, LIMITE_MENU_MBL, LIMITE_MENU_DKS;
var HEADER_LIMIT;
var POSPAGE;

var __ajaxFormContato = __BASESITE__ + "/enviar-form-contato";

var $window;

function exist(el) {
  return $(el).length;
}

$(document).ready(function () {
  var tag = document.createElement("script");

  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  $window = $(window);

  HEADER = ".main--header-fixo";
  MENU_LATERAL = "#menu-lateral";
  POSPAGE = 0;

  HEADER_INIT = $(HEADER).position().top;
  HEADER_FIM = 0;
  HEADER_LIMIT = 400;

  MENU_INIT = 0;
  LIMITE_MENU_MBL = 600;
  LIMITE_MENU_DKS = 320;
  MENU_FIM = 320;
  MENU_ABERTO = false;

  $(window).scroll(function () {
    var ph = $(HEADER).position();
    POSPAGE = $(this).scrollTop();

    if (POSPAGE > HEADER_LIMIT) {
      if (ph.top != HEADER_FIM && !MENU_ABERTO) showHeader(true);
    } else {
      if (ph.top != HEADER_INIT) showHeader(false);
    }
  });

  if ($(window).width() <= LARGURA_MOBILE) {
    TELA_DESKTOP = false;
    TELA_MOBILE = true;
  }

  // resize
  resizeMenu();
  $(window).resize(resizeMenu);

  $("#bt-menu-topo").click(function () {
    showMenu(true);
  });
  $("#bt-menu-topo-fixo").click(function () {
    showMenu(true);
  });

  // Formulário
  initFormContato();
});

function replaceResponsiveImages(classReference, pattern, sufx, isBg) {
  $(classReference).each(function (index, value) {
    var dds = isBg
      ? $(this).css("background-image").split(pattern)
      : $(this).attr("src").split(pattern);

    var src = dds[0] + pattern + sufx + dds[1];

    if (isBg) {
      $(this).css({ backgroundImage: src });
    } else {
      $(this).attr("src", src);
    }
  });
}

function resizeMenu() {
  var windowsize = $window.width();
  if (windowsize <= LIMITE_MENU_MBL) {
    LIMITE_MENU_MBL = windowsize;
    MENU_FIM = LIMITE_MENU_MBL;
  } else {
    MENU_FIM = LIMITE_MENU_DKS;
  }

  // if (MENU_ABERTO && $(MENU_LATERAL).width() != MENU_FIM) {
  //   $(MENU_LATERAL).css("width", MENU_FIM + "px");
  // }

  if (MENU_ABERTO) {
    if (TELA_MOBILE) {
      $(MENU_LATERAL).css("width", "100vw");
    } else {
      $(MENU_LATERAL).css("width", MENU_FIM + "px");
    }
  }
}

function overRotate() {
  if ($(MENU_LATERAL).width() < MENU_FIM) {
    return;
  }

  anime({
    targets: "#bt-close-svg",
    rotate: 180,
    duration: 400,
    easing: "easeInOutExpo",
    complete: function (anim) {
      $("#bt-close-svg").css({ WebkitTransform: "rotate(0deg)" });
      $("#bt-close-svg").css({ "-moz-transform": "rotate(0deg)" });
    },
  });
}

function showHeader(mostra, tempo) {
  tempo = tempo || 500;

  anime({
    targets: HEADER,
    top: mostra ? HEADER_FIM : HEADER_INIT,
    duration: tempo,
    easing: "easeInOutExpo",
  });
}

function showMenu(mostra) {
  MENU_ABERTO = mostra;
  // console.log("menu fim..." + MENU_FIM);
  if (mostra) {
    showHeader(false, 300);
  }

  anime({
    targets: MENU_LATERAL,
    width: mostra ? MENU_FIM : MENU_INIT,
    duration: 500,
    easing: "easeOutExpo",
    complete: function (anim) {
      if (!mostra && POSPAGE > HEADER_LIMIT) showHeader(true);
    },
  });
}

function scrollToAnchor(aid, os) {
  os = os || 0;

  var aTag = $("#" + aid);
  var pos = aTag.offset().top - 58 - os;
  var scrollElement = (scrollElement =
    window.document.scrollingElement ||
    window.document.body ||
    window.document.documentElement);

  anime({
    targets: scrollElement,
    scrollTop: pos,
    duration: 1000,
    easing: "easeInOutExpo",
  });
}

function ovrBlcVideo(b, over) {
  var contentVideo = "#bloco-proj-video-" + b;
  var contentImage = "#bloco-proj-image-" + b;

  if ($(contentVideo).length) {
    if (over) {
      $(contentVideo).removeClass("content--hidden");
      $(contentImage).css("opacity", 0);
    } else {
      $(contentVideo).addClass("content--hidden");
      $(contentImage).css("opacity", 1);
    }
  }
}

function ovrBlcProj(b, txt, full) {
  var bloco = "#bloco-proj-" + b;
  var barra = "#barra-tit-proj-" + b;

  var $window = $(window);
  var larg = txt ? pegaLargTxt(txt) : BARL;

  full = full || true;
  if (full) {
    if ($window.width() < 500 || larg > 500) larg = 500;
  } else {
    if (larg > 320) larg = 320;
  }
  // if(b!=1 && larg>320) larg = 320;
  // if(b==1 && ($window.width()<500 || larg>500)) larg = 500;

  if ($(bloco).is(":hover") && $(barra).width() > larg - 2) return;

  anime({
    targets: barra,
    width: larg,
    duration: 400,
    easing: "easeInOutExpo",
  });
}

function pegaLargTxt(txt) {
  var o = $("<div></div>")
    .html(txt)
    .addClass("calculate-semibold-width")
    .appendTo($("body"));
  var w = o.width();
  o.remove();
  return w;
}

function navega(url) {
  window.location.href = __BASESITE__ + "/" + url;
}

function isInView(elem) {
  return $(elem).offset().top - 600 - $(window).scrollTop() < $(elem).height();
}

// form contato rodapé

var checkData = {
  texto: function (text, size, rule) {
    size = size || 3;
    rule = rule || "min";
    if (rule == "min") return text.length >= size;
    if (rule == "max") return text.length <= size;
    if (rule == "exact") return text.length == size;
  },
  email: function (e) {
    var mailOk = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
    return mailOk.test(e);
  },
};
var fieldsErroClss = "erro-field";
var dtFieldsClss = $(".data-fields");
var $cttCampoNome = $("#contato-nome");
var $cttCampoEmail = $("#contato-email");
var $cttSelectDept = $("#contato-departamento");
var $cttChkAgreement = $("#contato-concordo");
var $cttChkAgreementLabel = $("#contato-concordo-label");
var cttSelectDeptTxt = "#contato-departamento option:selected";
var $cttTxtMsg = $("#contato-msg");
var $cttBtEnviar = $("#contato-enviar");
var $linkwa = $("#linkwa");
var $lds = $("#lds");

var enviandoForm = false;

function initFormContato() {
  $cttCampoNome.keyup(limpaErros);
  $cttCampoEmail.keyup(limpaErros);
  $cttTxtMsg.keyup(limpaErros);
  $cttChkAgreement.click(limpaErros);

  $cttSelectDept.change(function () {
    limpaErros();
    if ($(this).val() == "") $(this).addClass("empty");
    else $(this).removeClass("empty");
  });

  $cttSelectDept.change();

  $cttBtEnviar.click(function (event) {
    event.preventDefault();
    if (validaForm()) enviaForm();
  });

  $linkwa.click(function (event) {
    abreWA("51993048395");
  });
}

function abreWA(fone) {
  window.open("https://api.whatsapp.com/send?phone=55" + fone, "_blank");
}

function limpaErros() {
  dtFieldsClss.removeClass(fieldsErroClss);
  $cttChkAgreementLabel.removeClass(fieldsErroClss);
}

function validaForm() {
  limpaErros();

  var $campoErro = null;

  if (!checkData.texto($cttCampoNome.val())) $campoErro = $cttCampoNome;
  if (!$campoErro && !checkData.email($cttCampoEmail.val()))
    $campoErro = $cttCampoEmail;
  if (!$campoErro && !checkData.texto($cttSelectDept.val()))
    $campoErro = $cttSelectDept;
  if (!$campoErro && !checkData.texto($cttTxtMsg.val()))
    $campoErro = $cttTxtMsg;

  if (!$campoErro && !$cttChkAgreement.is(":checked"))
    $campoErro = $cttChkAgreementLabel;

  if ($campoErro) $campoErro.addClass(fieldsErroClss);

  return $campoErro == null;
}

function enviaForm() {
  if (enviandoForm) return;

  enviandoForm = true;

  $cttCampoNome.attr("disabled", "disabled");
  $cttCampoEmail.attr("disabled", "disabled");
  $cttSelectDept.attr("disabled", "disabled");
  $cttTxtMsg.attr("disabled", "disabled");

  $lds.removeClass("hidden");
  $cttBtEnviar.addClass("hidden");

  sendData(
    {
      nome: strip_tags($cttCampoNome.val()),
      email: strip_tags($cttCampoEmail.val()),
      departamento_nome: $(cttSelectDeptTxt).text(),
      departamento_email: $cttSelectDept.val(),
      mensagem: strip_tags($cttTxtMsg.val()),
    },
    __ajaxFormContato,
    onSendData
  );
}

function onSendData(data) {
  enviandoForm = false;

  $cttCampoNome.removeAttr("disabled");
  $cttCampoEmail.removeAttr("disabled");
  $cttSelectDept.removeAttr("disabled");
  $cttTxtMsg.removeAttr("disabled");

  $lds.addClass("hidden");
  $cttBtEnviar.removeClass("hidden");

  var toastMsg = data.ok
    ? "Obrigado pelo contato! Sua mensagem foi encaminhada."
    : "Falha no envio! Não foi possível enviar sua mensagem.";
  var toastType = data.ok ? "success" : "error";

  if (data.ok) {
    $cttCampoNome.val("");
    $cttCampoEmail.val("");
    $cttSelectDept.val("").change();
    $cttTxtMsg.val("");
  }

  $.toast({
    text: toastMsg, // Text that is to be shown in the toast

    icon: toastType, // Type of toast icon
    showHideTransition: "fade", // fade, slide or plain
    allowToastClose: true, // Boolean value true or false
    hideAfter: 3000, // false to make it sticky or number representing the miliseconds as time after which toast needs to be hidden
    stack: false, // false if there should be only one toast at a time or a number representing the maximum number of toasts to be shown at a time
    position: "bottom-center", // bottom-left or bottom-right or bottom-center or top-left or top-right or top-center or mid-center or an object representing the left, right, top, bottom values

    textAlign: "left", // Text alignment i.e. left, right or center
    loader: false, // Whether to show loader or not. True by default
    loaderBg: "#9EC600", // Background color of the toast loader
    beforeShow: function () {}, // will be triggered before the toast is shown
    afterShown: function () {}, // will be triggered after the toat has been shown
    beforeHide: function () {}, // will be triggered before the toast gets hidden
    afterHidden: function () {}, // will be triggered after the toast has been hidden
  });
}

function sendData(DADOS, url, callback) {
  $.ajax({
    type: "POST",
    dataType: "json",
    url: url,
    data: DADOS,
    cache: false,
    success: callback,
    error: function (errorThrown) {
      str = JSON.stringify(errorThrown, null, 4);
      console.log("+++ " + errorThrown.responseText);
      // var saidaErr = _.unescape(errorThrown.responseText);
      // window.open("about:blank").document.body.innerHTML = saidaErr;
    },
  });
}
